<nb-tabset (changeTab)="onChangeTab($event)">

    <!-- DESCARGAR ARCHIVOS -->

    <nb-tab *ngIf="usersRol.CONSULTAR_ARCHIVOS_USUARIOS" tabTitle="Instructivos" tabIcon="download-outline" responsive>
        <h3 style="margin-bottom: 2rem;">Seleccione un archivo PDF para descargarlo:</h3>

            <nb-card *ngIf="showSpinner" class="container" style="background-color: transparent; border-color: transparent;">
                <app-spinner></app-spinner>  
            </nb-card>      

            <div class="megaContainer " >
                <nb-card class="manualesContainer col-5" *ngFor="let manual of manuales">
                        <div class="col-2">
                            <img src="../../assets/img/622_adobe_pdf_file_icon.png" width="70px" alt="PDF File">
                        </div>
                        <div class="col-7 fileInfo">
                            <div>
                                <span class="texto">
                                    {{manual.descripcion}} 
                                </span><br>
                                <br>
                                <span>
                                    {{manual.nombre}}
                                </span><br>
                                <span class="smTexto">
                                    Última actualización: {{manual.fechaAlta}}
                                </span>
                            </div>
                        </div>
                        <div class="col-3">
                            <nb-card-body>
                                <button (click)="downloadManual(manual)" [value]="manual.id" class="DownManualBTN" > 
                                    <nb-icon icon="arrow-circle-down-outline" width="40px" ></nb-icon>
                                </button>
                            </nb-card-body>
                        </div>
                </nb-card>
            </div>
    </nb-tab>

    <!-- CARGAR UN ARCHIVO NUEVO -->

    <nb-tab *ngIf="usersRol.GESTIONAR_ARCHIVOS_USUARIOS" tabTitle="Alta" tabIcon="upload-outline"  responsive>            
        <div class='allElementsContainer2'> 

            <input type="file" class="file-input" [accept]="requiredFileType" (change)="onFileSelected($event)" #fileSelect>
            <div>
                <h3 *ngIf="!fileName" style="display: inline;">
                    Seleccione un archivo PDF para cargar: 
                </h3>
                <h3 *ngIf="fileName">
                    Archivo seleccionado: {{fileName}}
                </h3>
                <button *ngIf="!fileName" mat-mini-fab color="primary" class="SelectFileBTN"
                    (click)="fileSelect.click()"  title="Click para seleccionar archivo" style="margin-left: 1rem;">
                    <mat-icon>attach_file</mat-icon>
                </button>
            </div>
            <div class="file-upload">
                <label *ngIf="fileName" >Descripción: </label>
                <input *ngIf="fileName" type="text" [(ngModel)]="descripcion" required/>
            </div>

            <nb-card *ngIf="showSpinner" class="container" style="background-color: transparent; border-color: transparent;">
                <app-spinner></app-spinner>  
            </nb-card> 

            <div class="file-upload">
                <button class="CancelBTN" [disabled]="bloqueoCargar" (click)="cancelarCarga()" >
                    CANCELAR
                </button>
                <button class="UploadBTN" [disabled]="bloqueoCargar" (click)="cargarArchivo()" style="margin-left: 1rem;" >
                    GUARDAR
                </button>
            </div>

        </div>           
    </nb-tab>

    <!-- ELIMINAR UN ARCHIVO -->

    <nb-tab *ngIf="usersRol.GESTIONAR_ARCHIVOS_USUARIOS" tabTitle="Eliminar" tabIcon="file-remove-outline"  responsive>            
        <div class='allElementsContainer2'> 
            
            <div class="file-delete">
                <h3 style="margin-right: 1rem;" *ngIf='!selectedFile'>
                    Seleccione un archivo PDF para eliminarlo:
                </h3>
            </div>

            <nb-card *ngIf="showSpinner" class="container" style="background-color: transparent; border-color: transparent;">
                <app-spinner></app-spinner>  
            </nb-card> 

            <div class="megaContainer " >
                <nb-card class="manualesContainer col-5" *ngFor="let manual of manuales">
                        <div class="col-2">
                            <img src="../../assets/img/622_adobe_pdf_file_icon.png" width="70px" alt="PDF File">
                        </div>
                        <div class="col-7 fileInfo">
                            <div>
                                <span class="texto">
                                    {{manual.descripcion}} 
                                </span><br>
                                <br>
                                <span>
                                    {{manual.nombre}}
                                </span><br>
                                <span class="smTexto">
                                    {{manual.fechaAlta}}
                                </span>
                            </div>
                        </div>
                        <div class="col-3">
                            <nb-card-body>
                                <button (click)="open(manual.nombre, manual.id)" [value]="manual.id" class="DownManualBTN" > 
                                    <nb-icon icon="trash-2-outline" ></nb-icon>
                                </button>
                            </nb-card-body>
                        </div>
                </nb-card>
            </div>

        </div>           
    </nb-tab>
</nb-tabset>

